<sdds-theme name="scania"></sdds-theme>
<nav class='sdds-nav'>
  <div class='sdds-nav__left'>
    <div class='sdds-nav__app-name'>Truck Manager</div>
  </div>

  <div class='sdds-nav__center'>
    <ul class='sdds-nav__inline-menu'>

      <li class='sdds-nav__item' routerLink="welcome" routerLinkActive="sdds-nav__item--active">
        <a class='sdds-nav__item-core'>
          <p class='sdds-nav__item-core-text'>Welcome</p>
        </a>
      </li>

      <li class='sdds-nav__item' routerLink="trucks" routerLinkActive="sdds-nav__item--active">
        <a class='sdds-nav__item-core'>
          <p class='sdds-nav__item-core-text'>Trucks</p>
        </a>
      </li>
    </ul>
  </div>

  <div class='sdds-nav__right'>
    <a class='sdds-nav__item sdds-nav__app-logo' href='#'></a>
  </div>
</nav>
<main class="content-container">
  <router-outlet></router-outlet>
</main>